module.exports = __webpack_public_path__ + "img/en-us.1975b8c6.svg";